import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { AlbumsProvider } from './context/AlbumsContext';
import MeusAlbuns from './pages/MeusAlbuns';
import MinhasFigurinhas from './pages/MinhasFigurinhas';
import Faltam from './pages/Faltam';
import ScannerSticker from './pages/ScannerSticker';
import './App.css';

function App() {
    const [currentPage, setCurrentPage] = useState('albums');

    useEffect(() => {
        ReactGA.initialize('G-HGDLW46D2F');
    }, []);

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: `/${currentPage}`,
            title: `Caça Figurinhas - ${currentPage}`,
        });
    }, [currentPage]);

    return (
        <AlbumsProvider>
            {currentPage === 'albums' && <MeusAlbuns onNavigate={setCurrentPage} />}
            {currentPage === 'figurinhas' && <MinhasFigurinhas onNavigate={setCurrentPage} />}
            {currentPage === 'faltam' && <Faltam onNavigate={setCurrentPage} />}
            {currentPage === 'scanner' && <ScannerSticker onNavigate={setCurrentPage} />}
        </AlbumsProvider>
    );
                }

    export default App;